module.exports = __webpack_public_path__ + "img/shayne.1545d9ff.png";